import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const top = () => window.scrollTo({ top: 0, left: 0, behavior: "instant" });

export const ScrollToTop = () => {
  const { pathname, search, hash, key } = useLocation();
  const prev = useRef(null);
  useLayoutEffect(() => { if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual"; }, []);
  useLayoutEffect(() => {
    const p = prev.current;
    prev.current = { pathname, search };
    if (p && p.pathname === pathname && p.search !== search && !hash) return undefined;
    top();
    if (!hash) return undefined;
    const t = setTimeout(() => document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView(), 300);
    return () => clearTimeout(t);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};
